import React, { useState, useEffect } from "react";
import { FaTimes, FaPlus } from "react-icons/fa";
import axios from "axios";
import { useParams } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const EducationInformationModelPopup = ({ updateEducationData }) => {
  const { userId } = useParams();
  const [educationData, setEducationData] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchEducationData();
  }, []);

  const fetchEducationData = async () => {
    try {
      const response = await axios.get(`${apiUrl}/employees/education-info/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (Array.isArray(response.data.educationInfo)) {
        setEducationData(response.data.educationInfo);
        updateEducationData(response.data.educationInfo);
      } else {
        console.error('Fetched education data is not an array:', response.data);
      }
    } catch (error) {
      console.error('Error fetching education data:', error);
    }
  };

  const handleAddMore = () => {
    setEducationData((prevData) => [
      ...prevData,
      {
        university: "",
        degree: "",
        specialization: "",
        grade: "",
        years: "",
      },
    ]);
  };

  const handleRemove = (index) => {
    setEducationData((prevData) => {
      const updatedData = [...prevData];
      updatedData.splice(index, 1);
      return updatedData;
    });
  };

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const list = [...educationData];
    list[index][name] = value;
    setEducationData(list);
  };

  const handleSave = () => {
    const formattedEducationInfo = educationData.map((info) => {
      return {
        institution: info.university,
        degree: info.degree,
        specialization: info.specialization,
        grade: info.grade,
        completionYears: info.years,
      };
    });

    const requestData = {
      educationInfo: formattedEducationInfo,
    };

    axios
      .post(`${apiUrl}/employees/updateeducationinfo/${userId}`, requestData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        fetchEducationData();
        console.log('Response from API:', response.data);
        alert('Data saved successfully!');
      })
      .catch((error) => {
        console.error('Error while saving data:', error);
        alert('Failed to save data. Please try again.');
      });
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedData = Array.from(educationData);
    const [movedItem] = reorderedData.splice(result.source.index, 1);
    reorderedData.splice(result.destination.index, 0, movedItem);
    setEducationData(reorderedData);
  };

  return (
    <div id="education_info" className="modal custom-modal fade" role="dialog">
      <div
        className="modal-dialog modal-lg"
        style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "90%" }}
        role="document"
      >
        <div className="modal-content h-100">
          <div className="modal-header">
            <h5 className="modal-title">Education Information</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div
            className="modal-body"
            style={{
              maxHeight: "calc(100vh - 120px)",
              overflowY: "auto",
            }}
          >
            <form>
              <div className="table-responsive">
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="educationData">
                    {(provided) => (
                      <table className="table" {...provided.droppableProps} ref={provided.innerRef}>
                        <thead>
                          <tr>
                            <th>University/Board</th>
                            <th>Degree/Diploma</th>
                            <th>Specialization</th>
                            <th>Grade/Percentage</th>
                            <th>Completion Years</th>
                            <th>
                              <FaPlus
                                className="mb-3"
                                style={{ cursor: "pointer", fontSize: "18px" }}
                                onClick={handleAddMore}
                              />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {educationData.map((info, index) => (
                            <Draggable key={index} draggableId={`${index}`} index={index}>
                              {(provided) => (
                                <tr
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <td>
                                    <input
                                      type="text"
                                      name="university"
                                      value={info.university}
                                      onChange={(e) => handleInputChange(index, e)}
                                      className="form-control"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      name="degree"
                                      value={info.degree}
                                      onChange={(e) => handleInputChange(index, e)}
                                      className="form-control"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      name="specialization"
                                      value={info.specialization}
                                      onChange={(e) => handleInputChange(index, e)}
                                      className="form-control"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      name="grade"
                                      value={info.grade}
                                      onChange={(e) => handleInputChange(index, e)}
                                      className="form-control"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      name="years"
                                      value={info.years}
                                      onChange={(e) => handleInputChange(index, e)}
                                      className="form-control"
                                    />
                                  </td>
                                  <td>
                                    <FaTimes
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleRemove(index)}
                                    />
                                  </td>
                                </tr>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </tbody>
                      </table>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EducationInformationModelPopup;
